import {helpers} from 'vuelidate/lib/validators'

// validator for provider handles
export const providerHandle =
  helpers.regex ('providerHandle', /^[A-Za-z0-9]+-[A-Za-z0-9]+$/)

// validator for provider chains
export const providerChain =
  helpers.regex ('providerChain', /^(\{[A-Za-z0-9]+-[A-Za-z0-9]+\})+$/)
